import { Component, Inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { AlertService } from '../alert.service';

import { ApplicationUser } from '../user';

import { AuthService } from '../auth.service';

@Component({
  selector: 'app-user-manager',
  templateUrl: './user-manager.component.html',
  styleUrls: ['./user-manager.component.scss']
})
export class UserManagerComponent {
  public applicationUsers: ApplicationUser[];
  searchUser;
  constructor(
    private http: HttpClient,
    private alert: AlertService,
    public auth: AuthService,
    @Inject('BASE_URL') private baseUrl: string) {
    http.get<ApplicationUser[]>(baseUrl + 'api/ApplicationUsers/List').subscribe(result => {
      this.applicationUsers = [];
      for (let i in result) {
        if (result[i].midStageAccountsAccess == true || result[i].deactivatedNumbersAccess == true || result[i].textRepliesAccess == true || result[i].isUserManager == true || result[i].agentDNCEntriesAccess == true) {
          this.applicationUsers[i] = result[i];
          console.log(this.applicationUsers[i]);
        }
      }
      console.log(this.applicationUsers);
    }, error => {
      this.alert.error(`Error getting user list`, false, 5);
      console.error(error)
    });
  }

  saveUser(user: ApplicationUser): void {
    this.http.post<boolean>(this.baseUrl + 'api/ApplicationUsers/Save', user).subscribe(result => {
      if (result == true) {
        this.alert.success(`Successfully saved ${user.userId}`, false, 3);
      }
      else {
        this.alert.warn(`Unable to save ${user.userId}`, false, 5);
      }
    }, error => {
      this.alert.error(`Error saving ${user.userId}`, false, 5);
      console.error(error)
    });
  }
  deleteUser(user: ApplicationUser): void {
    this.http.post<boolean>(this.baseUrl + 'api/ApplicationUsers/Delete', user).subscribe(result => {
      if (result == true) {
        this.alert.success(`Successfully saved ${user.userId}`, false, 3);
      }
      else {
        this.alert.warn(`Unable to save ${user.userId}`, false, 5);
      }
    }, error => {
      this.alert.error(`Error deleting ${user.userId}`, false, 5);
      console.error(error)
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/user-manager/user-manager.component.ts